<aside class="marketplace__sidebar" *ngIf="filter" [ngClass]="{'active': showMobile}">
  <div class="marketplace__sidebar-header active">
    <h2>{{ 'filter_creature.header.title' | translate }}</h2>
    <button class="marketplace__sidebar-close" (click)="showMobileChange.emit(false)">
      <close-icon-component></close-icon-component>
    </button>
  </div>
  <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">
      {{ 'filter_creature.dropdowns.creature_type' | translate }}
    </h3>
    <div class="dropdown__content">
      <a class="dropdown__content-link orange" (click)="onChooseCreatureType(creatureType.Moonbits)"
        [ngClass]="{'active': isChoosenCreatureType(creatureType.Moonbits)}">
        <span>
          <creature-type-icon-component [type]="creatureType.Moonbits"></creature-type-icon-component>
        </span> {{ 'creature_types.moonbits' | translate }} </a>
      <a class="dropdown__content-link blue" (click)="onChooseCreatureType(creatureType.Zunnie)"
        [ngClass]="{'active': isChoosenCreatureType(creatureType.Zunnie)}">
        <span>
          <creature-type-icon-component [type]="creatureType.Zunnie"></creature-type-icon-component>
        </span> {{ 'creature_types.zunnies' | translate }} </a>
      <a class="dropdown__content-link purple" (click)="onChooseCreatureType(creatureType.Sharkman)"
        [ngClass]="{'active': isChoosenCreatureType(creatureType.Sharkman)}">
        <span>
          <creature-type-icon-component [type]="creatureType.Sharkman"></creature-type-icon-component>
        </span> {{ 'creature_types.sharkman' | translate }} </a>
      <a class="dropdown__content-link green" (click)="onChooseCreatureType(creatureType.Oregon)"
        [ngClass]="{'active': isChoosenCreatureType(creatureType.Oregon)}">
        <span>
          <creature-type-icon-component [type]="creatureType.Oregon"></creature-type-icon-component>
        </span> {{ 'creature_types.oregon' | translate }} </a>
    </div>
  </div>
  <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">
      {{ 'filter_creature.dropdowns.price' | translate }}
    </h3>
    <div class="dropdown__content">
      <div class="dropdown__content-price">
        <input type="number" class="dropdown__content-input" [(ngModel)]="filter.minPrice" (blur)="onFilterChange()">
        <div class="dropdown__content-line"></div>
        <input type="number" class="dropdown__content-input" [(ngModel)]="filter.maxPrice" (blur)="onFilterChange()">
      </div>
    </div>
  </div>
  <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">
      {{ 'filter_creature.dropdowns.breeding_info' | translate }} </h3>
    <div class="dropdown__content">
      <div class="dropdown__content-checkbox">
        <input type="checkbox" id="parent" [(ngModel)]="filter.isParent" (change)="onFilterChange()">
        <label for="parent">{{ 'filter_creature.breeding_info.parent' | translate }}</label>
      </div>
      <div class="dropdown__content-checkbox">
        <input type="checkbox" id="children" [(ngModel)]="filter.isChildren" (change)="onFilterChange()">
        <label for="children">{{ 'filter_creature.breeding_info.children' | translate }}</label>
      </div>
    </div>
  </div>
  <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">{{ 'filter_creature.creature_level.header.title' | translate }}</h3>
    <div class="dropdown__content">
      <div class="dropdown__content-star">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" rx="4" fill="#24140A" />
          <path
            d="M22.8754 12.7665C22.8256 12.6199 22.734 12.4911 22.6119 12.396C22.4898 12.3009 22.3425 12.2437 22.1882 12.2313L17.6749 11.8727L15.7219 7.54939C15.6597 7.41015 15.5585 7.29188 15.4306 7.20886C15.3027 7.12585 15.1534 7.08163 15.0009 7.08154C14.8484 7.08146 14.6992 7.12551 14.5711 7.20839C14.4431 7.29127 14.3418 7.40942 14.2795 7.5486L12.3264 11.8727L7.81313 12.2313C7.66149 12.2433 7.51652 12.2988 7.39557 12.391C7.27462 12.4833 7.1828 12.6084 7.1311 12.7515C7.07941 12.8945 7.07002 13.0494 7.10407 13.1977C7.13812 13.346 7.21416 13.4813 7.32309 13.5874L10.6584 16.8388L9.4788 21.9466C9.44298 22.1013 9.45446 22.2631 9.51175 22.4111C9.56903 22.5591 9.66948 22.6864 9.80006 22.7767C9.93063 22.8669 10.0853 22.9157 10.244 22.917C10.4027 22.9182 10.5581 22.8716 10.69 22.7834L15.0007 19.9097L19.3113 22.7834C19.4461 22.873 19.6052 22.9191 19.767 22.9155C19.9288 22.912 20.0857 22.8589 20.2165 22.7636C20.3473 22.6682 20.4457 22.5351 20.4986 22.3821C20.5515 22.2291 20.5563 22.0636 20.5123 21.9079L19.0643 16.8412L22.6553 13.6096C22.8904 13.3974 22.9767 13.0665 22.8754 12.7665Z"
            fill="#AD69FE" />
        </svg>
        <input class="dropdown__content-range" type="range" min="1" max="100" value="100">
      </div>
      <div class="dropdown__content-price">
        <input type="number" class="dropdown__content-input" [(ngModel)]="filter.minLevel" (blur)="onFilterChange()">
        <div class="dropdown__content-line"></div>
        <input type="number" class="dropdown__content-input" [(ngModel)]="filter.maxLevel" (blur)="onFilterChange()">
      </div>
    </div>
  </div>
  <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">{{ 'filter_creature.ability_list.header.title' | translate }}</h3>
    <div class="dropdown__content dropdown-select first">
      <div class="custom-select">
        <span class="custom-select__trigger custom-select__dropdown">{{selectedAbilityNames.length == 0 ? 'All' : (selectedAbilityNames.length) + ' Ablilies'}}</span>
        <ul class="select">
          <div class="select__search">
            <button class="select__search-btn">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.625 14.875C17.0938 15.375 17.0938 16.1562 16.625 16.6562C16.125 17.125 15.3438 17.125 14.8438 16.6562L11.125 12.9062C9.84375 13.75 8.28125 14.1875 6.59375 13.9688C3.71875 13.5625 1.40625 11.2188 1.03125 8.375C0.5 4.125 4.09375 0.53125 8.34375 1.0625C11.1875 1.4375 13.5312 3.75 13.9375 6.625C14.1562 8.3125 13.7188 9.875 12.875 11.125L16.625 14.875ZM3.46875 7.5C3.46875 9.71875 5.25 11.5 7.46875 11.5C9.65625 11.5 11.4688 9.71875 11.4688 7.5C11.4688 5.3125 9.65625 3.5 7.46875 3.5C5.25 3.5 3.46875 5.3125 3.46875 7.5Z"
                  fill="white"></path>
              </svg>
            </button>
            <input type="text" class="select__search-input" placeholder="Search ..." [(ngModel)]="searchAbility"
              (input)="onSearchAbility()">
          </div>
          <li class="select__item" *ngFor="let ability of abilities">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" [id]="ability.id" [checked]="isChoosenAbility(ability.id)"
                (change)="onChooseAbility(ability.id)">
              <label [for]="ability.id">{{lang && ability.nameTranslations ? ability.nameTranslations[lang] : ability.name}}</label>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">{{ 'filter_creature.creature_hp.header.title' | translate }}</h3>
    <div class="dropdown__content">
      <div class="dropdown__content-heart">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" rx="4" fill="#24140A" />
          <path
            d="M21.4965 8.79288C21.06 8.35328 20.5409 8.0043 19.969 7.766C19.3972 7.52769 18.7839 7.40477 18.1644 7.4043C16.9926 7.40449 15.8635 7.84468 15.0009 8.63771C14.1383 7.84455 13.0092 7.40433 11.8374 7.4043C11.2171 7.40494 10.6031 7.52824 10.0307 7.76709C9.45832 8.00595 8.9388 8.35564 8.50207 8.79605C6.63928 10.6668 6.64007 13.5928 8.50365 15.4555L15.0009 21.9528L21.4981 15.4555C23.3616 13.5928 23.3624 10.6668 21.4965 8.79288Z"
            fill="#96F184" />
        </svg>
        <input class="dropdown__content-range" type="range" min="1" max="100" value="100">
      </div>
      <div class="dropdown__content-price">
        <input type="number" class="dropdown__content-input" [(ngModel)]="filter.minHp" (blur)="onFilterChange()">
        <div class="dropdown__content-line"></div>
        <input type="number" class="dropdown__content-input" [(ngModel)]="filter.maxHp" (blur)="onFilterChange()">
      </div>
    </div>
  </div>
  <!-- <div class="dropdown">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">Body parts</h3>
    <div class="dropdown__content dropdown-select">
      <div class="custom-select">
        <span class="custom-select__trigger custom-select__dropdown">All</span>
        <ul class="select">
          <div class="select__search">
            <button class="select__search-btn">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.625 14.875C17.0938 15.375 17.0938 16.1562 16.625 16.6562C16.125 17.125 15.3438 17.125 14.8438 16.6562L11.125 12.9062C9.84375 13.75 8.28125 14.1875 6.59375 13.9688C3.71875 13.5625 1.40625 11.2188 1.03125 8.375C0.5 4.125 4.09375 0.53125 8.34375 1.0625C11.1875 1.4375 13.5312 3.75 13.9375 6.625C14.1562 8.3125 13.7188 9.875 12.875 11.125L16.625 14.875ZM3.46875 7.5C3.46875 9.71875 5.25 11.5 7.46875 11.5C9.65625 11.5 11.4688 9.71875 11.4688 7.5C11.4688 5.3125 9.65625 3.5 7.46875 3.5C5.25 3.5 3.46875 5.3125 3.46875 7.5Z"
                  fill="white"></path>
              </svg>
            </button>
            <input type="text" class="select__search-input" placeholder="Search ...">
          </div>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody1" checked>
              <label for="Abilitybody1">Ability name</label>
            </div>
          </li>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody2">
              <label for="Abilitybody2">Ability name</label>
            </div>
          </li>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody3">
              <label for="Abilitybody3">Ability name</label>
            </div>
          </li>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody4">
              <label for="Abilitybody4">Ability name</label>
            </div>
          </li>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody5">
              <label for="Abilitybody5">Ability name</label>
            </div>
          </li>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody6">
              <label for="Abilitybody6">Ability name</label>
            </div>
          </li>
          <li class="select__item">
            <div class="dropdown__content-checkbox">
              <input type="checkbox" id="Abilitybody7">
              <label for="Abilitybody7">Ability name</label>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div> -->
  <div class="dropdown last">
    <h3 class="dropdown__title" (click)="toggleDropdown($event)">
      {{ 'filter_creature.dropdowns.rarity' | translate }}
    </h3>
    <div class="dropdown__content">
      <div class="marketplace__rarity">
        <div class="dropdown__content-checkbox">
          <input type="checkbox" id="common" [checked]="isChoosenRarity(creatureRarity.Common)">
          <label for="common" (click)="onChooseRarity(creatureRarity.Common)">
            <div class="rarity common">{{ 'filter_creature.rarity.common' | translate }}</div>
          </label>
        </div>
        <div class="dropdown__content-checkbox">
          <input type="checkbox" id="rare" [checked]="isChoosenRarity(creatureRarity.Rare)">
          <label for="rare" (click)="onChooseRarity(creatureRarity.Rare)">
            <div class="rarity rare">{{ 'filter_creature.rarity.rare' | translate }}</div>
          </label>
        </div>
        <div class="dropdown__content-checkbox">
          <input type="checkbox" id="legendary" [checked]="isChoosenRarity(creatureRarity.Legendary)">
          <label for="legendary" (click)="onChooseRarity(creatureRarity.Legendary)">
            <div class="rarity legendary">{{ 'filter_creature.rarity.legendary' | translate }}</div>
          </label>
        </div>
      </div>
    </div>
  </div>

  <button class="marketplace__sidebar-clear button-secondary">
    {{ 'filter_creature.buttons.clear_all' | translate }}
  </button>
</aside>